import type { Transaction } from "@/api/transactions";

export function isSetupComplete(
	creditCards: unknown[],
	bankAccounts: unknown[],
	transactions: Transaction[],
): boolean {
	const hasCreditCard = creditCards.length > 0;
	const hasBankAccount = bankAccounts.length > 0;
	const hasTransferIn = transactions.some(
		(t) => t.transaction_type_name === "Deposit",
	);
	const hasTransferOut = transactions.some(
		(t) => t.transaction_type_name === "Withdrawal",
	);
	return hasCreditCard && hasBankAccount && hasTransferIn && hasTransferOut;
}
